import {
  Text,
  IconPlus,
  Primary14SemiBold,
  Button,
  useModalState,
  Box,
  Flex
} from '@sequencehq/core-components'
import { useCustomerContactsLayout } from './useCustomerContactsLayout'
import { CreateContactModal } from '../modals/CreateContactModal'
import { ContactTable } from './ContactTable/ContactTable'
import { ProtectedComponent } from 'lib/rbac'

export const CustomerContactsLayout = () => {
  const { buttonAddContact, contacts } = useCustomerContactsLayout()
  const { isModalOpen, openModal, closeModal } = useModalState()

  return (
    <Box px={4} pb={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Text {...Primary14SemiBold}>Contacts</Text>
        <ProtectedComponent permission="org.customer:update">
          <Button
            variant="ghost"
            leadingIcon={<IconPlus />}
            data-testid="contacts.addContact"
            onClick={() => {
              buttonAddContact.onClick()
              openModal()
            }}
          >
            Add Contact
          </Button>
        </ProtectedComponent>
      </Flex>
      {isModalOpen && (
        <CreateContactModal
          isOpen
          onClose={closeModal}
          purposes={contacts.length ? undefined : ['BILLING']}
        />
      )}
      <Box mt={2}>
        <ContactTable />
      </Box>
    </Box>
  )
}
